import { AnimationOptions } from 'ngx-lottie';
import cameraLoading from 'src/assets/lottie/camera-loading.json';
import lightbulb from 'src/assets/lottie/lightbulb.json';
import loading from 'src/assets/lottie/loading.json';
import scanning from 'src/assets/lottie/scanning.json';
import successBlue from 'src/assets/lottie/success-blue.json';

/** Bundled Lottie data. animationData avoids a runtime fetch of assets/lottie/*.json. */
export const cameraLoadingAnimation: AnimationOptions = { animationData: cameraLoading, loop: true, autoplay: true };
export const lightbulbAnimation: AnimationOptions = { animationData: lightbulb, loop: false, autoplay: true };
export const loadingAnimation: AnimationOptions = { animationData: loading, loop: true, autoplay: true };
export const scanningAnimation: AnimationOptions = { animationData: scanning, loop: true, autoplay: true };
export const successBlueAnimation: AnimationOptions = { animationData: successBlue, loop: false, autoplay: true };
